
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#A2B8C6","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#F4F6F9","x":".5","y":".5","width":"27","height":"27","rx":"3"}}),_c('rect',{attrs:{"fill":"#F4F6F9","x":"31.5","y":".5","width":"27","height":"27","rx":"3"}}),_c('path',{attrs:{"fill":"#A2B8C6","d":"M32.5 18.5h25v1h-25zm-31 0h25v1h-25zm0 30h25v1h-25z"}}),_c('rect',{attrs:{"fill":"#F4F6F9","x":"31.5","y":"31.5","width":"27","height":"27","rx":"3"}}),_c('rect',{attrs:{"fill":"#F4F6F9","x":".5","y":"31.5","width":"27","height":"27","rx":"3"}}),_c('path',{attrs:{"fill":"#A2B8C6","d":"M1.5 50.5h25v1h-25zm31 0h25v1h-25z"}})])])
          )
        }
      }
    